const createEtransferFromFileStyle = {
};

export default createEtransferFromFileStyle;
